import { FeedbackFormData } from '../../components/feedback-form/feedback-types';

export const osmFormData: FeedbackFormData = {
  id: 'public-landscape-objects',
  title: $localize`We'd like to hear some more`,
  subtitle: $localize`We promise it will only take a few minutes of your time, and your answers are of high value for us`,
  questions: [
    [
      {
        id: 'statements',
        title: $localize`To what extent do you agree on the following statements`,
        type: 'radio-block',
        options: [
          {
            id: 'operation',
            label: $localize`During a field operation, it's important to know the location of objects in the field`,
          },
          {
            id: 'plan',
            label: $localize`When planning the field work, it's important to know the location of objects in the field`,
          },
          { id: 'easy-recording', label: $localize`I find it easy to record objects manually` },
          {
            id: 'registries',
            label: $localize`I believe it is possible to find most of the objects I need in the public registries `,
          },
          { id: 'distrust', label: $localize`I don't trust the public registries and worry about the accuracy` },
          { id: 'contribute', label: $localize`I want to contribute to the online registry you use for this tool` },
        ],
      },
      {
        id: 'would-use',
        title: $localize`Why would or wouldn't you use a tool like this?`,
        subtitle: $localize`Please add a comment below`,
        type: 'textarea',
      },
    ],
    [
      {
        id: 'recording',
        title: $localize`How are you currently recording objects in your fields?`,
        subtitle: $localize`Select one or more answers`,
        type: 'check-block',
        options: [
          { id: 'terminal', label: $localize`In the tractor's terminal` },
          { id: 'mobile', label: $localize`On a mobile app when I'm in the field` },
          { id: 'fms', label: $localize`In a farm management system at the office` },
          { id: 'none', label: $localize`I don’t record objects ` },
        ],
        wildcard: {
          label: $localize`Other`,
          placeholder: '',
        },
      },
      {
        id: 'review',
        title: $localize`How often are you reviewing, editing or deleting your stored objects?`,
        subtitle: $localize`Select the answer that best applies to your current practice`,
        type: 'radio',
        options: [
          { id: 'before', label: $localize`Before each operation` },
          { id: 'monthly', label: $localize`Monthly` },
          { id: 'semi-annually', label: $localize`2-3 times a year` },
          { id: 'yearly', label: $localize`Yearly (e.g. before or after a season)` },
          { id: 'never', label: $localize`Never` },
        ],
        wildcard: {
          label: $localize`Other`,
          placeholder: '',
        },
      },
    ],
    [
      {
        id: 'objects',
        title: $localize`How important are the following object types for the planning and execution of your field work?`,
        subtitle: $localize`Select the level of importance for each object`,
        type: 'radio-block',
        options: [
          { id: 'lakes', label: $localize`Lakes` },
          { id: 'streams', label: $localize`Streams` },
          { id: 'windmills', label: $localize`Windmills` },
          { id: 'power-poles', label: $localize`Power poles` },
          { id: 'shelter-belts', label: $localize`Shelter belts` },
          { id: 'roads', label: $localize`Roads` },
          { id: 'buildings', label: $localize`Buildings` },
        ],
        values: [
          { id: 'not', label: $localize`Not important` },
          { id: 'moderately', label: $localize`Moderately important` },
          { id: 'very', label: $localize`Very important` },
        ],
      },
      {
        id: 'other-objects',
        title: $localize`Are there any other object types that are important for your field work?`,
        subtitle: $localize`Please add a comment below`,
        type: 'textarea',
      },
    ],
    [
      {
        id: 'usage',
        title: $localize`Where do you imagine using a tool like this?`,
        subtitle: $localize`Select one or more answers`,
        type: 'check-block',
        options: [
          { id: 'terminal', label: $localize`In the tractor's terminal` },
          { id: 'online', label: $localize`Online on a tablet or smartphone` },
          { id: 'fms', label: $localize`In a farm management system on my computer` },
        ],
        wildcard: {
          label: $localize`Other`,
          placeholder: '',
        },
      },
      {
        id: 'features',
        title: $localize`Please indicate for each of the following features whether you consider it a 'Need to have' or a 'Nice to have' for a tool like this?`,
        subtitle: $localize`Select the level of relevancy for each feature`,
        type: 'radio-block',
        options: [
          { id: 'cloud', label: $localize`Cloud connection for easy transfer of objects without a USB stick` },
          { id: 'selection', label: $localize`Selection of a specific type of object for download` },
          { id: 'individuals', label: $localize`Selection of individual objects for download` },
          {
            id: 'categories',
            label: $localize`Possibility to categorize objects as 'Objects to avoid' or 'Objects for information'`,
          },
        ],
        values: [
          { id: 'need', label: $localize`Need to have` },
          { id: 'nice', label: $localize`Nice to have` },
          { id: 'not', label: $localize`Not relevant` },
        ],
      },
    ],
    [
      {
        id: 'pricing',
        title: $localize`At what price would you consider a product like this?`,
        subtitle: $localize`Please add a price in the four categories below, based on what you currently know about the idea - don't worry, you can't do anything wrong.`,
        type: 'pricing',
        options: [
          {
            id: 'too-low',
            label: $localize`At what price would you think the price is too low, that the product must be of bad quality? (Too cheap)`,
          },
          {
            id: 'good-value',
            label: $localize`At what price would you think the product is a bargain - a great buy for the money? (Cheap/Good value)`,
          },
          {
            id: 'expensive',
            label: $localize`At what price would you think the product is not out of the question, but you would have to give it some thoughts? (Expensive)`,
          },
          {
            id: 'too-expensive',
            label: $localize`At what price would you think the price is so expensive that you would not consider buying it? (Too expensive)`,
          },
        ],
      },
    ],
    [
      {
        id: 'anything-else',
        title: $localize`Anything else you'd like to share`,
        subtitle: $localize`Please add add any other comments, ideas and change requests, you would like to share with us`,
        type: 'textarea',
      },
      {
        id: 'email',
        title: $localize`E-mail contact`,
        subtitle: $localize`In case we need more information, we would like to contact you on the e-mail address you gave us when signing up.`,
        type: 'consent',
        options: [
          { id: 'mail', label: $localize`By ticking this box you allow us to get in contact with you by e-mail.` },
        ],
      },
    ],
  ],
};
